import React, { Component, Fragment } from 'react';
import API from '../shared/forms/API';
import Modal from '../shared/Modal';

export default class NotificationPreviewModal extends Component {
  state = { open: false, loading: false, preview: null, error: null };

  isControlled = () => this.props.open !== undefined;

  isOpen = () => (this.isControlled() ? this.props.open : this.state.open);

  componentDidMount() {
    if (this.isControlled() && this.props.open) {
      this.fetchPreview();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.isControlled() &&
      this.props.open &&
      (!prevProps.open || prevProps.uuid !== this.props.uuid)
    ) {
      this.fetchPreview();
    }
  }

  onTriggerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!this.state.open) {
      this.fetchPreview();
    }
    this.setState({ open: !this.state.open });
  };

  close = () => {
    if (this.isControlled()) {
      this.props.onClose && this.props.onClose();
    } else {
      this.setState({ open: false });
    }
  };

  fetchPreview = () => {
    this.setState({ loading: true, error: null, preview: null });
    new API()
      .fetch(`notifications/${this.props.uuid}/preview`)
      .then((res) => res.json())
      .then((preview) => this.setState({ preview, loading: false }))
      .catch(() => this.setState({ error: 'Kon preview niet laden', loading: false }));
  };

  render() {
    const { loading, preview, error } = this.state;
    return (
      <Fragment>
        {!this.isControlled() && (
          <a href="#preview" onClick={this.onTriggerClick} className="gray">
            <i className="fa fa-eye" />
          </a>
        )}
        {this.isOpen() && (
          <Modal title="Notificatie preview" onClose={this.close}>
            {loading && <p>Laden...</p>}
            {error && <p className="text-danger">{error}</p>}
            {preview && this.renderPreview()}
          </Modal>
        )}
      </Fragment>
    );
  }

  renderPreview() {
    const { preview } = this.state;
    if (preview.type === 'sms') {
      return <p style={{ whiteSpace: 'pre-wrap' }}>{preview.body}</p>;
    }
    return (
      <Fragment>
        {preview.subject && (
          <p>
            <strong>Onderwerp:</strong> {preview.subject}
          </p>
        )}
        {preview.html ? (
          <div dangerouslySetInnerHTML={{ __html: preview.html }} />
        ) : (
          <pre className="bg-light p-3">{preview.body}</pre>
        )}
      </Fragment>
    );
  }
}
